export const REQUIRED_DOCUMENTS_ICONS = [
  {
    icon: 'https://assets.clear.in/cleartax/images/1716794500_frame1814104993.svg',
    label: 'PAN Card',
  },
  {
    icon: 'https://assets.clear.in/cleartax/images/1716794489_frame18141049931.svg',
    label: 'Aadhaar',
  },
  {
    icon: 'https://assets.clear.in/cleartax/images/1716794476_frame18141049932.svg',
    label: 'Bank account',
  },
  {
    icon: 'https://assets.clear.in/cleartax/images/1716794467_frame1814104994.svg',
    label: 'Form 16',
  },
  {
    icon: 'https://assets.clear.in/cleartax/images/1716794458_frame18141049933.svg',
    label: 'Other Income',
  },
  {
    icon: 'https://assets.clear.in/cleartax/images/1716794449_frame18141049934.svg',
    label: 'Investment Details',
  },
];

export const META_DATA = {
  canonical: 'https://cleartax.in/s/cleartax-itr-filing-guide',
  title: 'ClearTax ITR Filing Guide',
  description:
    'Watch this comprehensive ClearTax ITR Filing Guide to learn how to easily file your Income Tax Return on ClearTax.  Learn step-by-step how to navigate the ClearTax platform and accurately file your ITR hassle-free.',
  keywords:
    'cleartax itr filing guide, cleartax itr filing video, cleartax itr filing, cleartax file itr, cleartax free itr filing, itr filing cleartax',
};

//To get back to the same entity after viewing the guide
export const LOCAL_STORAGE_GUIDE_KEYS = {
  guideEntityId: 'guideEntityId',
  guideEntityIndex: 'guideEntityIndex',
  guideFinancialYear: 'guideFinancialYear',
};

export const DEFAULT_ACTIVE_VERTICAL_TAB = 'linkPanPreFill';
export const DEFAULT_ACTIVE_HORIZONTAL_TAB = 'quickSummary';
